import React, { Component } from 'react';
import { NavBar, TimeOut, BreadCumb } from '../../components';
import { DISPATCH_ID } from '../../libs/utils/Const';
import { connect } from 'react-redux';
import config from '../../config';
import moment from 'moment';
import { ApiClient } from '../../libs/apiClient';
import '../../css/tablesPOS.css';
let apiClient = ApiClient.getInstance();

class NotificationManagement extends Component {
    constructor(props) {
        super(props);
        this.state = {
            _user: JSON.parse(localStorage.getItem(config.localStorageNamed + 'currentUser')),
            itemsDashboard: JSON.parse(localStorage.getItem(config.localStorageNamed + 'itemsDashboard')),
            sucursales: [],
            pk_Sucursal: '',
            notifications: [],
            title: '',
            message: '', 
            typesNot: [{value: 0, name: 'Error'}, {value: 1, name: 'Exito'}, {value: 2, name: 'Información'}, {value: 3, name: 'Advertencia'}, {value: 4, name: 'Aviso'}], 
            type: -1,
            timeOut: '', 
            destinatiosnNot: [{value: 1, name: 'Todos'}, {value: 2, name: 'Usuario'}, {value: 3, name: 'Sucursal'}], // value 4 ocupado para Referidos
            destination: -1,
            userCode: '',
        }
    }

    componentDidMount = async () => {
        this._handelBack();
        await this.getAllNotifications();
    }

    _handelBack = () => {
        window.location.hash = "no-back-button";
        window.location.hash = "Again-No-back-button";
        window.onhashchange = function () { window.location.hash = "no-back-button"; }
    };

    getSucursales = async () => {
        const { sucursales } = this.state; 
        const { enableSpinner } = this.props;

        if(sucursales.length < 1){
            enableSpinner(true);
            let listsucursales = await apiClient.getDataNotifications('2');
            this.setState({sucursales: listsucursales.data || []});
            enableSpinner(false);
        }
    }

    getAllNotifications = async () => {
        const { enableSpinner } = this.props;

        enableSpinner(true);
        let notifications = await apiClient.getDataNotifications('1');
        this.setState({notifications: notifications.data || []});
        enableSpinner(false);
    }

    onChangeInputs = async (e) => {
        let { name, value } = e.target;
        if(name === 'destination' || name === 'type' || name === 'pk_Sucursal' || name === 'timeOut'){
            if (name === 'timeOut' && isNaN(value)){
                return;
            }
            value = Number(value);
            if(name === 'destination' && value === 3){
                await this.getSucursales();
            }
        }

        if(name === 'message' && value.length > 255) {
            return;
        }

        this.setState({[name]: value});
    }

    saveNotification = async () => {
        const { pk_Sucursal, title, message, type, timeOut, destination, userCode } = this.state;
        const { notificationReducer: { showAlert }, enableSpinner } = this.props;

        if(title === '' || message  === '' || type  === -1 || timeOut  === '' || destination === -1){
            showAlert({type: 'warning', message: `Debe completar la información de la notificación`, timeOut: 4000 });
            return;
        }

        if(timeOut === 0){
            showAlert({type: 'warning', message: `El tiempo deber ser mayor a 0`, timeOut: 4000 });            
        }

        switch (destination) {
            case 2:
                if(userCode === ''){
                    showAlert({type: 'warning', message: `Ingrese el código de usuario`, timeOut: 4000 });
                    return;
                }
                break;
            case 3:
                if(pk_Sucursal === ''){
                    showAlert({type: 'warning', message: `Elige una sucursal`, timeOut: 4000 });
                    return;
                }
            default:
                break;
        }

        const data = { pk_Sucursal, title, message, type, timeOut: timeOut * 1000, destination, userCode };

        enableSpinner(true);
        const response = await apiClient.saveNotification(data);
        enableSpinner(false);
    
        if(response.status === 1){
            showAlert({type: 'success', message: response.message, timeOut: 4000 });
            this.clearInputs();
            await this.getAllNotifications();
        }else{
            showAlert({type: 'error', message: response.message, timeOut: 4000 });
        }
    };

    clearInputs = () => {
        this.setState({
            pk_Sucursal: '',
            title: '',
            message: '', 
            type: -1,
            timeOut: '', 
            destination: -1,
            userCode: '',
        });
    }

    processText = (text, condition = false) => {
        const urlRegex = /(https?:\/\/[^\s]+)/g;
    
        return text.split(urlRegex).map((part, index) => {
            if (part.match(urlRegex)) {
                return <a key={index} href={part} target="_blank" rel="noopener noreferrer" style={{ color: '#337AFF' }}>{part}</a>;
            }
            return part;
        });
    };

    render() {
        const { _user, itemsDashboard,  sucursales, pk_Sucursal, notifications, title} = this.state;
        const { message, typesNot, type, timeOut, destinatiosnNot, destination, userCode } = this.state;
        return (
            <div className="content">
                <NavBar props={this.props} itemsDashboard={itemsDashboard} _user={_user} />
                <TimeOut />
                <BreadCumb subitem1={'NOTIFICACIONES'} url1={'#'} />
                <div style={{ marginLeft: "5.5rem", marginRight: "1rem" }}>
                    <div className="row mb-3">
                        <h3 className="col-12">Crear Notificación</h3>
                    </div>
                    <div className="row">
                        <div className="col-12">
                            <div className="row mb-3">
                                <div className="col-md-3 mb-2">
                                    <div className="input-group">
                                        <div className="input-group-prepend">
                                            <span className="input-group-text"><strong>Titulo</strong></span>
                                        </div>
                                        <input
                                            className="form-control"
                                            type="text" 
                                            value={title}
                                            name="title"
                                            onChange={(e) => this.onChangeInputs(e)}
                                        />
                                    </div>
                                </div>
                                <div className="col-md-4 mb-2">
                                    <div className="input-group">
                                        <div className="input-group-prepend">
                                            <span className="input-group-text"><strong>Mensaje</strong></span>
                                        </div>
                                        <input
                                            className="form-control"
                                            type="text" 
                                            value={message}
                                            name="message"
                                            placeholder="255 caracteres máximo"
                                            onChange={(e) => this.onChangeInputs(e)}
                                        />
                                    </div>
                                    {message.length === 255 &&
                                        <div className="text-danger small mt-2">
                                            No tiene más caracteres disponibles
                                        </div>
                                    }
                                </div>
                                <div className="col-md-3 mb-2">
                                    <div className="input-group">
                                        <div className="input-group-prepend">
                                            <span className="input-group-text"><strong>Tiempo de Visibilidad</strong></span>
                                        </div>
                                        <input
                                            className="form-control"
                                            type="text"
                                            value={timeOut}
                                            name="timeOut"
                                            placeholder="segs."
                                            onChange={(e) => this.onChangeInputs(e)}
                                            />
                                    </div>
                                </div>
                            </div>
                            <div className="row mb-3">
                                <div className="col-md-3 mb-2">
                                    <div className="input-group">
                                        <div className="input-group-prepend">
                                            <span className="input-group-text" id="basic-addon1"><strong>Tipo</strong></span>
                                        </div>
                                        <select
                                            className="form-control"
                                            value={type}
                                            name="type"
                                            onChange={(e) => this.onChangeInputs(e)}
                                            >
                                            <option value={-1}>Elige una opción</option>
                                            {typesNot.map((option, index) => {
                                                return (
                                                        <option key={index} value={option.value}> {option.name}</option>
                                                    );
                                                })
                                            }
                                        </select>
                                    </div>
                                </div>
                                <div className="col-md-3 mb-2">
                                    <div className="input-group">
                                        <div className="input-group-prepend">
                                            <span className="input-group-text" id="basic-addon1"><strong>Enviar a</strong></span>
                                        </div>
                                        <select
                                            className="form-control"
                                            value={destination}
                                            name="destination"
                                            onChange={(e) => this.onChangeInputs(e)}
                                            >
                                            <option value={-1}>Elige una opción</option>
                                            {destinatiosnNot.map((option, index) => {
                                                return (
                                                        <option key={index} value={option.value}> {option.name}</option>
                                                    );
                                                })
                                            }
                                        </select>
                                    </div>
                                </div>

                                {destination === 2 && (
                                    <div className="col-md-3 mb-2">
                                        <div className="input-group">
                                            <div className="input-group-prepend">
                                                <span className="input-group-text"><strong>Código de Usuario</strong></span>
                                            </div>
                                            <input
                                                className="form-control"
                                                type="text"
                                                value={userCode}
                                                name="userCode"
                                                onChange={(e) => this.onChangeInputs(e)}
                                                />
                                        </div>
                                    </div>
                                )}

                                {destination === 3 && (
                                    <div className="col-md-3 mb-2">
                                        <div className="input-group">
                                            <div className="input-group-prepend">
                                                <span className="input-group-text" id="basic-addon1"><strong>Sucursal</strong></span>
                                            </div>
                                            <select
                                                className="form-control"
                                                value={pk_Sucursal}
                                                name="pk_Sucursal"
                                                onChange={(e) => this.onChangeInputs(e)}
                                                >
                                               <option value={-1}>Elige una opción</option>
                                                {sucursales.map((option, index) => {
                                                    return (
                                                            <option key={index} value={option.pk_Sucursal}> {option.nombre}</option>
                                                        );
                                                    })
                                                }
                                            </select>
                                        </div>
                                    </div>
                                )}

                                <div className="col-md-2 mb-2 d-flex justify-content-end">
                                    <button type="button" className="btn btn-primary" onClick={this.saveNotification}>
                                        <i className="fa fa-save mr-2" aria-hidden="true"></i>Crear
                                    </button>
                                </div>
                            </div>
                            <div className="row mb-3">
                                <div className="col-12">
                                    <div className="card scrollTableRePrint  mb-5">
                                        <table className="table table-striped table-hover">
                                            <thead className="sticky-headerPOS" style={{ background: "white" }}>
                                                <tr>
                                                    <th className="text-center">Creación</th>
                                                    <th className="text-center" style={{ width: '20%' }}>Titulo</th>
                                                    <th className="text-center" style={{ width: '30%' }}>Mensaje</th>
                                                    <th className="text-center">Visibilidad</th>
                                                    <th className="text-center">Tipo</th>
                                                    <th className="text-center">Enviada a</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                            {notifications.length > 0 ?
                                                notifications.map((notification, index) => {
                                                    return (
                                                        <tr key={index}>
                                                            <td className="text-center align-middle">{moment(notification.creation_date).format('YYYY-MM-DD H:mm:ss')}</td>
                                                            <td className="text-center align-middle text-break">{notification.title}</td>
                                                            <td className="text-center align-middle text-break">{this.processText(notification.message)}</td>
                                                            <td className="text-center align-middle">{notification.timeout / 1000} segs.</td>
                                                            <td className="text-center align-middle">{(typesNot.find(type => type.value === notification.type))?.name}</td>
                                                            <td className="text-center align-middle">{(destinatiosnNot.find(destination => destination.value === notification.destination))?.name}</td>
                                                        </tr>
                                                    );
                                                })
                                            : 
                                                <tr className="text-center" key="no-data">
                                                    <td className="text-center align-middle" colSpan="6">No se encontraron notificaciones</td>
                                                </tr>
                                            }
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = store => {
    return { notificationReducer: store.NotificationReducer };
};

const mapDispatchToProps = dispatch => {
    return {
        enableSpinner: value => dispatch({ type: DISPATCH_ID.CONFIG_SET_SPINNER, value })
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(NotificationManagement);